import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import LoginForm from './components/LoginForm';
import Dashboard from './pages/Dashboard';

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notAdmin, setNotAdmin] = useState(false);
  const [showAdminError, setShowAdminError] = useState(false);

  useEffect(() => {
    const getSessionData = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setSession(session);
      setLoading(false);
    };

    getSessionData();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);
    });

    const sessionCheck = setInterval(async () => {
      const { data: { session: currentSession }, error } = await supabase.auth.getSession();
      if (error || !currentSession) {
        setSession(null);
        await supabase.auth.signOut();
      }
    }, 60000);

    return () => {
      subscription.unsubscribe();
      clearInterval(sessionCheck);
    };
  }, []);

  useEffect(() => {
    const checkAdmin = async () => {
      if (session?.user) {
        const roles = session.user.user_metadata?.role || [];
        if (!roles.includes('admin')) {
          setNotAdmin(true);
          setShowAdminError(true);
          setTimeout(async () => {
            if (session) {
              await supabase.auth.signOut();
              setSession(null);
            }
          }, 2000);
        } else {
          setNotAdmin(false);
          setShowAdminError(false);
        }
      }
    };
    checkAdmin();
  }, [session]);

  if (loading) {
    return <div>Carregando...</div>; 
  }

  if (notAdmin && showAdminError) {
    return <LoginForm errorMsg="Apenas administradores podem acessar este painel." />;
  }

  return (
    <div className="App">
      {!session ? <LoginForm /> : <Dashboard session={session} />}
    </div>
  );
}

export default App;